export default "__VITE_ASSET__3d0ad671__"